// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__QARkd","login":"Auth_login__8BNIE","login-logo":"Auth_login-logo__OSKpM","login-form":"Auth_login-form__dIWWM"};